import React from "react";
import { FormGroup } from "../../UI/FormGroup";
import { FormControlLabel } from "../../UI/FormControlLabel";
import { Switch as MUISwitch, SwitchProps } from "../../UI/Switch";
import { COLOR_FIORD } from "../../constants/styles";

interface IProps {
  isDisabled?: boolean;
  label?: string | React.ReactNode;
  switchProps?: SwitchProps;
}

const formControlLabelSX = {
  "& .MuiFormControlLabel-label": {
    color: COLOR_FIORD,
  },
};

export const Switch: React.FC<IProps> = (props) => (
  <FormGroup>
    <FormControlLabel
      label={props.label}
      sx={formControlLabelSX}
      disabled={props.isDisabled}
      control={<MUISwitch {...props.switchProps} />}
    />
  </FormGroup>
);

Switch.defaultProps = {
  isDisabled: false,
};
